export const FEATURE_NAME: string = 'blob-feature';

export interface IBlobState {
  mainBlob: {};
}

export const initialBlobState: IBlobState = {
  mainBlob: null,
};
